import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { sectionNames } from "@dashboard/intl";
import { useIntl } from "react-intl";
import { type RouteComponentProps, Switch } from "react-router-dom";

import { atticAssetDirectoryListPath, atticAssetDirectoryPath } from "./urls";
import AtticAssetDirectoryDetailsView from "./views/AtticAssetDirectoryDetails";
import AtticAssetDirectoryListView from "./views/AtticAssetDirectoryList";

const DirectoryDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <AtticAssetDirectoryDetailsView id={decodeURIComponent(match.params.id)} />
);

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.atticDigitalAssets)} />
      <Switch>
        <Route exact path={atticAssetDirectoryListPath} component={AtticAssetDirectoryListView} />
        <Route exact path={atticAssetDirectoryPath(":id")} component={DirectoryDetails} />
      </Switch>
    </>
  );
};

export default Component;
